module.exports = __webpack_public_path__ + "img/lets_celebrate.a27879ed.png";